<template>
  <div>
    <md-progress-bar v-if="loading" md-mode="indeterminate"></md-progress-bar>
    <div class="mobile-list">
      <div class="mobile-card">
        <div class="mobile-card__img">
          <img
            v-touch:swipe="imageSwipeHandler"
            :src="productImage"
            :alt="product.name"
          />
        </div>
        <div class="mobile-card__box">
          <p class="custom-p">
            <span>Заказ:</span>
            <strong>{{ product.orderNumber }}</strong>
          </p>
          <p class="custom-p">
            <span>Корзина:</span>
            <strong>{{ product.cartNumber }}</strong>
          </p>
          <p class="custom-p">
            <span>Артикул:</span>
            <strong>{{ form.articleFrom }}</strong>
          </p>
          <p class="custom-p">
            <span>Размер:</span>
            <strong>{{ form.sizeFrom }}</strong>
          </p>
        </div>
      </div>

      <div class="mobile-card">
        <div class="mobile-card__img">
          <img v-if="form.image" :src="form.image" :alt="form.articleTo" />
          <img
            v-if="productToImage && !form.image"
            :src="productToImage"
            :alt="form.articleTo"
          />
        </div>
        <div class="mobile-card__box">
          <p class="custom-p">
            <span>Заказ:</span>
            <strong>{{ product.orderNumber }}</strong>
          </p>
          <p class="custom-p">
            <span>Корзина:</span>
            <strong>{{ product.cartNumber }}</strong>
          </p>
          <p class="custom-p">
            <span>Артикул:</span>
            <strong
              :class="{ 'custom-changed': form.articleTo !== form.articleFrom }"
            >
              {{ form.articleTo }}
            </strong>
          </p>
          <p class="custom-p">
            <span>Размер:</span>
            <strong
              :class="{ 'custom-changed': form.sizeTo !== form.sizeFrom }"
            >
              {{ form.sizeTo }}
            </strong>
          </p>
        </div>
      </div>
    </div>

    <form class="md-layout" @submit.prevent="validateForm">
      <md-card class="md-layout-item custom-no-margin md-xsmall-hide">
        <md-card-media>
          <img
            v-touch:swipe="imageSwipeHandler"
            :src="productImage"
            :alt="product.name"
          />
        </md-card-media>
        <div class="card-custom-content">
          <p class="custom-p">
            <span>Заказ:</span>
            <strong>{{ product.orderNumber }}</strong>
          </p>
          <p class="custom-p">
            <span>Корзина:</span>
            <strong>{{ product.cartNumber }}</strong>
          </p>
          <p class="custom-p">
            <span>Артикул:</span>
            <strong>{{ form.articleFrom }}</strong>
          </p>
          <p class="custom-p">
            <span>Размер:</span>
            <strong>{{ form.sizeFrom }}</strong>
          </p>
        </div>
      </md-card>
      <div class="md-layout-item md-size-65 md-xsmall-size-100">
        <div class="custom-tab">
          <md-tabs md-alignment="centered">
            <template slot="md-tab" slot-scope="{ tab }">
              <i
                class="custom-icon md-icon md-icon-font md-tab-icon md-theme-default"
              >
                {{ tab.icon }}
              </i>
              <span class="custom-label">{{ tab.label }}</span>
            </template>
            <md-tab id="tab-photo" md-label="Фото" md-icon="camera_enhance">
              <md-field :class="getValidationClass('image')">
                <input
                  type="file"
                  @change="proxyImage"
                  accept="image/*;capture=camera"
                />
                <span class="md-error" v-if="!$v.form.image.required">
                  Нужно добавить фото замены
                </span>
                <div v-if="restErrors.image.length" class="md-error">
                  <span
                    v-for="(error, index) in restErrors.image[0].message"
                    :key="index"
                  >
                    {{ error }}
                  </span>
                </div>
              </md-field>
              <md-field :class="getValidationClass('comment')">
                <label>Комментарий</label>
                <md-textarea md-autogrow v-model="form.comment"></md-textarea>
                <div v-if="restErrors.comment.length" class="md-error">
                  <span
                    v-for="(error, index) in restErrors.comment[0].message"
                    :key="index"
                  >
                    {{ error }}
                  </span>
                </div>
              </md-field>
            </md-tab>
            <md-tab id="tab-size" md-label="Размер" md-icon="straighten">
              <md-field :class="getValidationClass('sizeTo')">
                <label>Размер замены</label>
                <md-input v-model="form.sizeTo"></md-input>
                <span class="md-error" v-if="!$v.form.sizeTo.required">
                  Нужно указать размер замены
                </span>
                <div v-if="restErrors.sizeTo.length" class="md-error">
                  <span
                    v-for="(error, index) in restErrors.sizeTo[0].message"
                    :key="index"
                  >
                    {{ error }}
                  </span>
                </div>
              </md-field>
              <md-field :class="getValidationClass('comment')">
                <label>Комментарий</label>
                <md-textarea md-autogrow v-model="form.comment"></md-textarea>
                <div v-if="restErrors.comment.length" class="md-error">
                  <span
                    v-for="(error, index) in restErrors.comment[0].message"
                    :key="index"
                  >
                    {{ error }}
                  </span>
                </div>
              </md-field>
            </md-tab>
            <md-tab id="tab-article" md-label="Артикл" md-icon="article">
              <md-field :class="getValidationClass('articleTo')">
                <label>Артикул замены</label>
                <md-input type="number" v-model="form.articleTo"></md-input>
                <span class="md-error" v-if="!$v.form.articleTo.required">
                  Нужно указать артикул замены
                </span>
                <div v-if="restErrors.articleTo.length" class="md-error">
                  <span
                    v-for="(error, index) in restErrors.articleTo[0].message"
                    :key="index"
                  >
                    {{ error }}
                  </span>
                </div>
              </md-field>
              <md-field :class="getValidationClass('comment')">
                <label>Комментарий</label>
                <md-textarea md-autogrow v-model="form.comment"></md-textarea>
                <div v-if="restErrors.comment.length" class="md-error">
                  <span
                    v-for="(error, index) in restErrors.comment[0].message"
                    :key="index"
                  >
                    {{ error }}
                  </span>
                </div>
              </md-field>
            </md-tab>
            <md-tab id="tab-comment" md-label="Коммент" md-icon="comment">
              <md-field :class="getValidationClass('comment')">
                <label>Комментарий</label>
                <md-textarea md-autogrow v-model="form.comment"></md-textarea>
                <div v-if="restErrors.comment.length" class="md-error">
                  <span
                    v-for="(error, index) in restErrors.comment[0].message"
                    :key="index"
                  >
                    {{ error }}
                  </span>
                </div>
              </md-field>
            </md-tab>
          </md-tabs>
          <div>
            <ul
              class="error-list"
              v-for="errorKey in Object.keys(restErrors)"
              :key="errorKey"
            >
              <li v-if="restErrors[errorKey].length">
                <span
                  style="color: var(--md-theme-default-fieldvariant, #ff1744)"
                  v-for="(error, index) in restErrors[errorKey][0].message"
                  :key="index"
                >
                  {{ error }}
                </span>
              </li>
            </ul>
          </div>
        </div>
        <div>
          <md-button
            v-if="!loading"
            v-on:click.prevent="clearForm"
            class="md-secondary"
            :disabled="loading"
          >
            Сбросить
          </md-button>
          <md-button type="submit" class="md-primary" :disabled="loading">
            Добавить
          </md-button>
        </div>
      </div>

      <!-- ==================== -->

      <md-card class="md-layout-item custom-no-margin md-xsmall-hide">
        <md-card-media>
          <!-- <div v-if="form.image">Фото замены</div> -->
          <img v-if="form.image" :src="form.image" :alt="form.articleTo" />
          <!-- <div v-if="productToImage && !form.image">Фото товара</div> -->
          <img
            v-if="productToImage && !form.image"
            :src="productToImage"
            :alt="form.articleTo"
          />
        </md-card-media>

        <div class="card-custom-content">
          <p class="custom-p">
            <span>Заказ:</span>
            <strong>{{ product.orderNumber }}</strong>
          </p>
          <p class="custom-p">
            <span>Корзина:</span>
            <strong>{{ product.cartNumber }}</strong>
          </p>
          <p class="custom-p">
            <span>Артикул:</span>
            <strong
              :class="{ 'custom-changed': form.articleTo !== form.articleFrom }"
            >
              {{ form.articleTo }}
            </strong>
          </p>
          <p class="custom-p">
            <span>Размер:</span>
            <strong
              :class="{ 'custom-changed': form.sizeTo !== form.sizeFrom }"
            >
              {{ form.sizeTo }}
            </strong>
          </p>
        </div>
      </md-card>
    </form>
  </div>
</template>

<script>
  import { validationMixin } from "vuelidate";
  import { required } from "vuelidate/lib/validators";

  export default {
    name: "ReplacementAdd",
    mixins: [validationMixin],
    data: () => ({
      form: {
        image: null,
        orderId: null,
        orderNumber: null,
        cartNumber: null,
        articleFrom: null,
        sizeFrom: null,
        articleTo: null,
        sizeTo: null,
        comment: null,
      },
      productToImage: null,
      productImage: null,
      restErrors: {
        image: [],
        orderId: [],
        orderNumber: [],
        cartNumber: [],
        articleFrom: [],
        sizeFrom: [],
        articleTo: [],
        sizeTo: [],
        comment: [],
      },
      product: null,
      loading: false,
    }),
    validations: {
      form: {
        image: {},
        orderId: {
          required,
        },
        orderNumber: {
          required,
        },
        cartNumber: {
          required,
        },
        articleFrom: {
          required,
        },
        sizeFrom: {
          required,
        },
        articleTo: {
          required,
        },
        sizeTo: {
          required,
        },
        comment: {},
      },
    },
    mounted() {
      this.productImage = this.holder;

      this.form.orderId = this.$route.params.orderId;
      this.form.orderNumber = this.$route.params.orderNumber;
      this.form.cartNumber = this.$route.params.cartNumber;
      this.form.articleFrom = this.$route.params.article;
      this.form.sizeFrom = this.$route.params.size;
      this.form.articleTo = this.$route.params.article;
      this.form.sizeTo = this.$route.params.size;
      this.form.comment = null;

      this.product = this.$store.getters["orders/getProductForReplace"](
        this.form.orderId,
        this.form.cartNumber,
        this.form.articleFrom,
        this.form.sizeFrom
      );
    },
    watch: {
      product() {
        this.productImage = this.holder;
        this.productToImage = this.holder;

        this.$nextTick(() => {
          this.productImage = this.product.images.small[0];
          this.$nextTick(() => {
            this.productImage = this.product.images.big[0];
          });

          this.productToImage = this.product.images.small[0];
          this.$nextTick(() => {
            this.productToImage = this.product.images.big[0];
          });
        });
      },
      "form.articleTo": function (next, old) {
        console.info(next, old);

        this.productToImage =
          "https://img.gepur.com/products/" +
          Math.ceil(next / 5000) * 5000 +
          `/` +
          next +
          "/simple/origins/" +
          next +
          "_1.jpg";
      },
    },
    computed: {
      holder() {
        return this.$store.state.holder.item;
      },
    },
    methods: {
      proxyImage(event) {
        const file = event.target.files[0];

        if (!file.type.includes("image/")) {
          this.$store.commit("messages/setMessage", {
            type: "error",
            code: "О нет!",
            message: "Зашружаемый файл должен быть картинкой",
          });

          return;
        }

        if (typeof FileReader !== "function") {
          this.$store.commit("messages/setMessage", {
            type: "error",
            code: "О нет!",
            message: "FileReader API  поддерживается",
          });

          return;
        }

        const reader = new FileReader();

        reader.onload = (event) => {
          this.form.image = event.target.result;
        };

        reader.readAsDataURL(file);
      },
      imageSwipeHandler(direction) {
        const index = this.product.images.big.indexOf(this.image);

        if (direction === "right") {
          if (index - 1 >= 0) {
            this.productImage = this.product.images.big[index - 1];
          } else {
            this.productImage = this.product.images.big[
              this.product.images.big.length - 1
            ];
          }
        }

        if (direction === "left") {
          if (index + 1 <= this.product.images.big.length - 1) {
            this.productImage = this.product.images.big[index + 1];
          } else {
            this.productImage = this.product.images.big[0];
          }
        }
      },
      getValidationClass(fieldName) {
        const field = this.$v.form[fieldName];

        if (this.restErrors[fieldName].length) {
          return {
            "md-invalid": true,
          };
        }

        if (field) {
          return {
            "md-invalid": field.$invalid && field.$dirty,
          };
        }
      },
      clearForm() {
        this.$v.$reset();
        this.form.image = null;
        if (this.$route.params.article && this.$route.params.orderId) {
          this.form.orderId = this.$route.params.orderId;
          this.form.orderNumber = this.$route.params.orderNumber;
          this.form.cartNumber = this.$route.params.cartNumber;
          this.form.articleFrom = this.$route.params.article;
          this.form.sizeFrom = this.$route.params.size;
          this.form.articleTo = this.$route.params.article;
          this.form.sizeTo = this.$route.params.size;
          this.form.comment = null;
        } else {
          this.form.articleFrom = null;
          this.form.orderId = null;
          this.form.orderNumber = null;
          this.form.cartNumber = null;
          this.form.sizeFrom = null;
          this.form.articleTo = null;
          this.form.sizeTo = null;
          this.form.comment = null;
        }

        this.form.image = null;
        this.restErrors = {
          image: [],
          orderId: [],
          orderNumber: [],
          cartNumber: [],
          articleFrom: [],
          sizeFrom: [],
          articleTo: [],
          sizeTo: [],
          comment: [],
        };
      },
      addReplacement() {
        this.loading = true;
        this.$axios
          .post("/replacement_add", this.form)
          .then(() => {
            this.$store.commit("messages/setMessage", {
              type: "success",
              code: "О да!",
              message: "Запрос на замену успешно отправлен",
            });

            this.$store.commit(
              "orders/setProductHasReplacementTrue",
              this.product
            );

            setTimeout(() => {
              this.$router.back();
            }, 500);
          })
          .catch((error) => {
            this.restErrors.orderId = error.response.data.filter(
              (err) => err.field === "orderId"
            );
            this.restErrors.orderNumber = error.response.data.filter(
              (err) => err.field === "orderNumber"
            );
            this.restErrors.cartNumber = error.response.data.filter(
              (err) => err.field === "cartNumber"
            );
            this.restErrors.image = error.response.data.filter(
              (err) => err.field === "image"
            );
            this.restErrors.articleFrom = error.response.data.filter(
              (err) => err.field === "articleFrom"
            );
            this.restErrors.sizeFrom = error.response.data.filter(
              (err) => err.field === "sizeFrom"
            );
            this.restErrors.articleTo = error.response.data.filter(
              (err) => err.field === "articleTo"
            );
            this.restErrors.sizeTo = error.response.data.filter(
              (err) => err.field === "sizeTo"
            );
            this.restErrors.comment = error.response.data.filter(
              (err) => err.field === "comment"
            );
          })
          .finally(() => {
            this.loading = false;
          });
      },
      validateForm() {
        this.$v.$touch();

        if (!this.$v.$invalid) {
          this.addReplacement();
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .card-custom-content {
    padding: 8px;
  }
  .custom-icon {
    // @media (min-width: 599px) {
    //   display: none;
    // }
  }
  .custom-label {
    @media (max-width: 340px) {
      display: none;
    }
  }

  .mobile-list {
    display: none;
    justify-content: space-between;
    box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2),
      0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
    margin-bottom: 4px;
    @media (max-width: 600px) {
      display: flex;
    }
  }

  .mobile-card {
    display: flex;
    &__img {
      height: 80px;
      background: #eee;
      img {
        height: 100%;
        max-width: 80px;
      }
    }

    &__box {
      font-size: 12px;
      line-height: 1.3em;
      padding: 8px;
    }
  }

  .custom-p {
    margin: 0;
  }

  .error-list {
    margin: 0;
  }
  .custom-content {
    padding-bottom: 0;
  }
  .custom-no-margin {
    margin: 0 !important;
  }
  .custom-changed {
    color: #ff5252;
  }
</style>
